<template>
  <section
    class="container d-flex flex-wrap gap-3 gap-md-6 justify-content-center justify-content-sm-between align-items-center text-center py-4 mb-lg-0"
    id="footer"
    style="text-align: center !important;
    align-items: center !important;
    justify-content: center !important;"
  >
    <span class="fs-eight fw-medium n5-color order-sm-1"
      >Copyright ©2025. All Rights Reserved.</span
    >
  </section>
</template>

<script>
export default {
  name: "AppFooter",
};
</script>
